var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("page.AdminPostCategoryManagement"))),
    ]),
    _vm._v(" "),
    _vm.hasEditorRole
      ? _c(
          "div",
          { staticClass: "block" },
          [
            _vm.isUseModalForCreate
              ? _c(
                  "a",
                  {
                    staticClass: "button",
                    on: {
                      click: function ($event) {
                        _vm.isModalActive = true
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.createNew")))]
                )
              : _c(
                  "router-link",
                  {
                    staticClass: "button",
                    attrs: {
                      to: {
                        path: `/admin/categories/${_vm.serviceId}/create`,
                        query: { parent: "root" },
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.createNew")))]
                ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("category-list-recursive", {
          attrs: { "parent-category-slug": "root" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }